import {DotLottieController, isDotLottieWC} from './DotLottieController';
import {attributeFilter, nodeAddedMap} from './MutationHandler';

const attribute = 'data-add-state-classes';

export const StateEventClassesController = Object.freeze({
  attribute,
  selector: `[${attribute}]`,
});

nodeAddedMap.set(StateEventClassesController.selector, (target) => {
  if (!target.matches(StateEventClassesController.selector)) {
    return;
  }

  const stateChangeHandler = (event: {type: string}) => {
    if (event.type === 'play') {
      target.classList.remove('state--complete');
      target.classList.add('state--playing');
    } else {
      target.classList.add('state--complete');
      target.classList.remove('state--playing');
    }
  };

  if (isDotLottieWC(target)) {
    DotLottieController.ensureLoaded().then(() => {
      if (!target.dotLottie) {
        return;
      }
      target.dotLottie.addEventListener('play', stateChangeHandler);
      target.dotLottie.addEventListener('complete', stateChangeHandler);
    });
  } else {
    target.addEventListener('play', stateChangeHandler);
    target.addEventListener('ended', stateChangeHandler);
  }
});

attributeFilter.add(attribute);
